"use client";

import { type ReactNode, ViewTransition } from "react";
import { useShopDisplaySettings } from "@/contexts/shop-display-settings-provider";

/** Tag a navigation with this so only that product's photo morphs, not its neighbours'. */
export function shopPhotoTransitionType(itemId: string) {
  return `shop-photo-${itemId}`;
}

/** Morphs a Storefront product photo between the shop grid and its product page during navigation. */
export function ShopPhotoTransition({
  itemId,
  children
}: {
  itemId?: string;
  children: ReactNode;
}) {
  // Next's bundled React has ViewTransition; plain React 19.2 (Jest) does not.
  const {
    photoTransitions
  } = useShopDisplaySettings();
  if (!photoTransitions || !itemId || !ViewTransition) return children;
  return <ViewTransition name={shopPhotoTransitionType(itemId)} share={{
    [shopPhotoTransitionType(itemId)]: "morph",
    default: "none"
  }} default="none">
      {children}
    </ViewTransition>;
}